/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import Icon from '../../icons/Icon';

export default class AboutUs extends Component {
    render() {
        const iconDefaultSize = '70px';

        return (
            <div className="app__contact-page__section about-us">
                <h5 className="vouchedfor-brand">
                    About VouchedFor
                </h5>
                <div className="under-title"></div>

                <div className="inline-block push-up-30">
                    <div className="app__grid__column__three-one padding-sides-20">
                        <div className="app__about-us__icon">
                            <Icon icon="genuine-reviews" size={ iconDefaultSize }/>
                        </div>
                        <div className="app__about-us__info__header">
                            Genuine client reviews
                        </div>
                        <div className="app__about-us__info font-lighter">
                            VouchedFor is the leading reviews website for professionals in the UK with thousands of
                            well reviewed professionals on board. Only genuine clients can review their adviser and
                            we verify every review.
                        </div>
                    </div>

                    <div className="app__grid__column__three-one padding-sides-20">
                        <div className="app__about-us__icon">
                            <Icon icon="star" size={ iconDefaultSize }/>
                        </div>
                        <div className="app__about-us__info__header">
                            Verified professionals
                        </div>
                        <div className="app__about-us__info font-lighter">
                            All Financial Advisers in our network are checked against the Financial Conduct Authority
                            Register, and must confirm they offer independent investment and pension advice,
                            and so are not tied to a particular product or provider
                        </div>
                    </div>

                    <div className="app__grid__column__three-one padding-sides-20">
                        <div className="app__about-us__icon">
                            <Icon icon="badge" size={ iconDefaultSize }/>
                        </div>
                        <div className="app__about-us__info__header">
                            Our guarantee
                        </div>
                        <div className="app__about-us__info font-lighter">
                            All of our advisers on VouchedFor are experts at what they do. However, if you’re not
                            completely satisfied with your adviser we will help you find someone else. There is no
                            obligation to continue with any adviser after receiving your plan.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/steps/shared/AboutUs.jsx